/* eslint-disable */
import LangPack from '../Languages/langPack';
import jslinq from 'js-linq'
export default {
    numberFormat:{
        formatPrice(value) {
            let val = (value/1).toFixed(2)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
    dateAndTime:{
        convertISODateStringToDate(isoDateString){
            try{
                let dmy = isoDateString.split("-");
                let d = +dmy[2];
                let m = +dmy[1]-1;
                let y = +dmy[0];
                let tDate = new Date(y,m,d);
                if (tDate.getMonth()===m){
                    return tDate;
                }else {
                    return null;
                }
            }
            catch(error){
                return false;
            }
        },
        isValidISODate(isoDateString){
            try{
                let dmy = isoDateString.split("-");
                let d = +dmy[2];
                let m = +dmy[1]-1;
                let y = +dmy[0];
                let tDate = new Date(y,m,d);
                if (tDate.getMonth()===m){
                    return true;
                }else {
                    return false;
                }
                return true;
            }
            catch(error){
                return false;
            }
        },
        calculateAge(birthday) { // birthday is a date
            var ageDifMs = Date.now() - birthday;
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        },        
        getTimeSlots(hStep, mStep){
            var maxH = 23;
            var maxM = 59;
            var slots = [];
            for (let i=0;i<=maxH;i += hStep){
                for (let j=0;j<=maxM;j+=mStep){
                    let h = i<10? "0"+i:i;
                    let m = j<10? "0"+ j:j;
                    slots.push (
                        {key:slots.length+1,code:h+''+m,text:h + ":" + m}
                    );
                }
            }
            slots.push({key:slots.length+1,code:'2359', text:"23:59"});
            return slots;
        },
        getFourDigitTimeWithColon(timeText){
            var tTime = '0000'+ timeText;
            var startPos = tTime.length-4;
            tTime = tTime.substring(startPos,tTime.length);
            tTime = tTime.substring(0,2) + ':' + tTime.substring(2,4);
            return tTime;
        },
        getDateValue(dateNum, timeNum){
            var y = dateNum.substring(0,4);
            var m = parseInt(dateNum.substring(4,6))-1;
            var d = dateNum.substring(6,8);

            var tTime = "";
            if (timeNum.length<4) {
                tTime = "0000" + timeNum;
                tTime = tTime.substring(tTime.length-4,tTime.length);
            }else {
                tTime = timeNum; 
            }
            var h = parseInt(tTime.substring(0,2));
            var mi = parseInt(tTime.substring(2,4));            
            var tDate = new Date(y,m,d,h,mi);
            return tDate;
        },
        getDateText(dateNum){
            var y = dateNum.substring(0,4);
            var m = parseInt(dateNum.substring(4,6))-1;
            var d = dateNum.substring(6,8);
            var tDate = new Date(y,m,d).toString();
            var tDateParts = tDate.substring(0,tDate.indexOf('00:')).split(' ');
            return tDateParts[0] + ", " + tDateParts[2] + " " + tDateParts[1] + " " + tDateParts[3].substring(2,4);
        },
        getDurationInMinutes(endDateNum,endTimeNum,nextStartDateNum,nextStartTimeNum){
            var date1 = this.getDateValue(endDateNum,endTimeNum);
            var date2 = this.getDateValue(nextStartDateNum,nextStartTimeNum);

            var diffTime = Math.abs(date2.getTime()-date1.getTime())/(1000*60);
            
            return diffTime;            
        },
        getTimeDuration(endDateNum,endTimeNum,nextStartDateNum,nextStartTimeNum){
            var minutes = this.getDurationInMunites(endDateNum,endTimeNum,nextStartDateNum,nextStartTimeNum);
            var m = minutes%60
            
            var h = (minutes - m)/60;
            
            return h + ":" + m;            
        },
        getDateYYYYMMDD(dateVal){
            var mm = dateVal.getMonth() + 1; // getMonth() is zero-based
            var dd = dateVal.getDate();
          
            return [dateVal.getFullYear(),
                    (mm>9 ? '' : '0') + mm,
                    (dd>9 ? '' : '0') + dd
                   ].join('');
        }       
    },
    display:{
        isMobile(breakpointName){
            return 'md,lg,xl'.indexOf(breakpointName)<0;
        },
        scrollToTop() {
            window.scrollTo(0,0);
        },          
    },
    logos:{
        qrCode:{
            path:'/assets/payment_img/',
            thaiQrPayment: function(){return this.path+"thai_qr_payment.png"},
        },
        banks:{
            path:'/assets/bank_logos/',
            scb: function() {return this.path+"scb.png"},
            kbank: function() {return this.path+ "kbank.png"},
            tmb:function(){return this.path+"tmb.png"},
            tbank:function(){return this.path+"tbank.png"},
            gsb:function(){return this.path+"gsb.png"},
            bay:function(){return this.path+"bay.png"},
            bbl:function(){return this.path+"bbl.png"},
            noImage:function(){return this.path+"no_img.png"},
            getByCode: function(code){
                let logo = this.noImage();
                try{
                    return this[code]();
                }catch(error){
                    return logo;
                }
            },
        }
    },
    queryString:{
        getParameterByName(name,url){
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));            
        },
    },
    textFormatValidation:{
        isEmail(email){
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(email) || false;
        },
    },
    keypressFiltering:{
        azAZSpace(v){
            if (v=="") return true;
            return /^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(v)||false;
        },
        azAZNumSpace(v){
            if (v=="") return true;
            return /^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/.test(v)||false;
        }        
    },    
    stringFormat:{
        bankAccountNumber(accountNo){
            let formatedAccountNo = "";
            if (accountNo.length == 10){
                formatedAccountNo = accountNo.substring(0,3) + "-" + accountNo.substring(3,9) + "-" + accountNo.substring(9,10)
            }else if (accountNo>10){
                formatedAccountNo =accountNo.substring(0,3) + "-" + accountNo.substring(3,9) + "-" + accountNo.substring(9,accountNo.length);
            }else{
                formatedAccountNo =accountNo;
            }
            return formatedAccountNo;
        },
    },
    colors:{
        required:"#fff082a1"
    },
    uiCaption:{
        getUiCaption(id){
            let linq = new jslinq(LangPack);
            let captions = linq.where(l=>l.id==id).toArray();
            if (captions.length>0){
                return captions[0]["textEn"];
            }else{
                return "";
            }
        },
    },
    sellingCurrency: {
      getSellingCurrency (flightFares) {
        const sc = {
          code: '',
          fxRate: 0.00
        }
        if (flightFares.SellingCurrency != null) {
          sc.code = flightFares.SellingCurrency.CurrencyCode
          sc.fxRate = flightFares.SellingCurrency.FxRate
        } else {
          sc.code = flightFares.Currency
          sc.fxRate = 1
        }
        return sc;
      },
      convertByFxRate(fxRate, amount){
        const amnt = Math.ceil(fxRate*amount)
        return amnt
      }
    }
}